import React, { useState, useEffect } from "react";
import { Container, Col, Row, Button, Form,InputGroup,FormControl,Image } from "react-bootstrap";
import score from '../assets/img/score.png'
import ReactCodeInput from "react-code-input";
import InputMask from 'react-input-mask';
import { useNavigate } from "react-router-dom";
import { apiUrl } from "../commons/inFormTypes";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loaders from '../components/Loaders'
import MaskInput from 'react-maskinput';
import Carousel from "react-multi-carousel";
import Ripples from 'react-ripples';
import charity from "../assets/img/charity.png"
import { useSpring, animated } from 'react-spring'

const props = {
  className: ReactCodeInput,
  inputStyle: {
    fontFamily: 'monospace',
    borderRadius: '6px',
    border: '1px solid lightgrey',
    boxShadow: 'rgb(0 0 0 / 10%) 0px 0px 10px 0px',
    margin: '3px',
    paddingLeft: '8px',
    width: '50px',
    height: '50px',
    fontSize: '32px',
    boxSizing: 'border-box',
    color: 'black',
    backgroundColor: 'white',
  }
}

function Wallet() {
  const [snipTransfer, setSnipTransfer] = useState(false);
  const [selectFile, setSelectFile] = useState(false);
  const [orgId, setOrgId] = useState(0);
  const [listOrg, setListOrg] = useState([]);
  const [snip1, setSnip1] = useState(false);
  const [snip3, setSnip3] = useState(false);
  const [snip4, setSnip4] = useState(false);
  const [codeMeli, setCodeMeli] = useState("");
  const [cartAlert, setCartAlert] = useState(false);
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [cartNumber, setCartNumber] = useState();
  const [Stchange, setstchange] = useState(false);
  const [code, setCode] = useState(0);
  const [cointTransfer, setCointTransfer] = useState();
  const [transaction, setTransaction] = useState(0);
  const [coint, setCoint] = useState(0);
  const [Sumcoint, setsumcoint] = useState("معادل:-");
  const [convertId, setConvertId] = useState(0);
  const [convertText, setConvertText] = useState("");
  const [listConvert, setListConvert] = useState([]);
  const [listUser, setListUser] = useState([]);
  const [tokenId, setTokenId] = useState();
  const [listTransaction, setListTransaction] = useState([]);
  const userToken = localStorage.getItem("user_token");
  const coints = Intl.NumberFormat('en-US').format(parseFloat(localStorage.getItem("Coints"))); //split tree number of coints  
  const navigate = useNavigate();

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  const orgBtn = useSpring({
    background: selectFile
      ? "#E78E09"
      : "#ced4da",

  });

  const personBtn = useSpring({
    background: selectFile
      ? "#ced4da"
      : "#E78E09",
  });

  const personClicked = () => {
    setSelectFile(false);
    // setCointTransfer("");
    // setCode("");
  }

  const orgClicked = () => {
    setSelectFile(true);
    setCointTransfer("");
    setCode("");
  }


  useEffect(() => {
    if (userToken == null) {
      navigate("/");
    } else {

      if (codeMeli === "" || codeMeli === null) {
        return;
      }
      const axios = require("axios");
      axios
        .post(apiUrl + "Get_ListCoints", {
          TokenId: userToken,
          Type: transaction,
          Code_Meli: codeMeli
        })
        .then((res) => {
          console.log(res.data.message)
          console.log(res.data.result)

          if (res.data.result === "true" && res.data.data_Users.Name !== null) {
            setTokenId(res.data.data_Users.TokenId)
            setName(res.data.data_Users.Name);
            setMobile(res.data.data_Users.Mobile);
            setListConvert(res.data.data_Convert);
            setListTransaction(res.data.data);
            if (res.data.data_Users.CardNumber !== null)
              setCartNumber(res.data.data_Users.CardNumber);
            else
              setCartNumber("");

            let sk = "100/1000/10";
          } else {
            setName("")
            setMobile("")
            setCartNumber("");
            setListConvert([]);
            setListTransaction([]);
            toast.error("کدملی موجود نمی باشد", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        })
        .catch(function (error) {
          if (error.response) {
            toast.error(error.response.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });  
        
        axios
        .post(apiUrl + "Get_Organization", {
          TokenId: userToken,
          Code_Meli: "",
          Type: 0
        })

        .then((res) => {
          if (res.data.result === "true") {
            setListOrg(res.data.data)
          } else {
          }
        })
        .catch(function (error) {
          if (error.response) {
            toast.error(error.response.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });
    }

  }, [Stchange, transaction]);

  const selectAreaHandler = (e) => {
    setConvertId(e.target.value);
    setConvertText(e.target.options[e.target.selectedIndex].text);
    let code = e.target.value.split("/")[1];
    let count = e.target.value.split("/")[2];
    if (coint !== "" && coint != null)
      setsumcoint((coint / code) * count)
  }

  const CointHandler = (e) => {
    setCoint(e.target.value)
    let code = convertId.split("/")[1];
    let count = convertId.split("/")[2];
    if (e.target.value !== "" && coint != null && convertId != "0")

      setsumcoint(" معادل : " + (e.target.value / code) * count)
    else
      setsumcoint(" معادل : -")
  }

  const convertHandler = (val) => {

    let coint1 = 0;
    if (val == 0) {
      coint1 = coint;
      if (coint == "" || convertId == 0) {
        toast.error("لطفا اطلاعات مورد نظر را وارد کنید", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        })
        return false;
      }

      setSnip3(true);
    } else if (val == 1) {
      coint1 = cointTransfer;
      if (code == "" || cointTransfer == "") {
        toast.error("لطفا اطلاعات مورد نظر را وارد کنید", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        })
        return false;
      }
      setSnip4(true);
    }

    const axios = require("axios");

    axios
      .post(apiUrl + "Insert_Score", {
        Coint: coint1,
        Type: val,
        Code: convertId,
        Tittle: convertText,
        Code_Dist: code,
        TokenId: userToken,
        Code_Meli: codeMeli,
      })

      .then((res) => {
        setSnip3(false);
        setSnip4(false);
        if (res.data.result === "true") {
          if (Stchange)
            setstchange(false)
          else
            setstchange(true)

          toast.success(res.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          toast.error(res.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      })
      .catch(function (error) {
        if (error.response) {
          toast.error(error.response.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      });

  }



  const searchHandler = (e) => {
    if (Stchange)
      setstchange(false)
    else
      setstchange(true)
  }



  const submitInfoHandler = () => {
    if ((codeMeli == "" || codeMeli.length > 10 || codeMeli.length < 10)
      || (mobile.length < 11 || mobile.length > 11 || mobile === "" || !mobile.startsWith("09"))
      || cartNumber == "" || cartNumber.length < 24 || name == "") {
      toast.error("لطفا اطلاعات صحیح را وارد نمایید", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      })
      return false;
    }

    const axios = require("axios");
    setSnip1(true);
    axios
      .post(apiUrl + "Register_Station", {
        TokenId: userToken,
        FirstName: name,
        Codemelli: codeMeli,
        mobile: mobile,
        CardNumber: cartNumber,
      })

      .then((res) => {
        setSnip1(false);
        if (res.data.result === "true") {
          if (Stchange)
            setstchange(false)
          else
            setstchange(true)

          toast.success(res.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          toast.error(res.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      })
      .catch(function (error) {
        if (error.response) {
          toast.error(error.response.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      });
  }

  //enter for input insted of click button
  const keyPress = (e) => {
    if (e.keyCode === 13) {
      searchHandler(e)
    }
  }

  //Focus on the Next Field
  const handleEnter = (event) => {
    if (event.key.toLowerCase() === "enter") {
      const form = event.target.form;
      const index = [...form].indexOf(event.target);
      form.elements[index + 1].focus();
      event.preventDefault();
    }
  };


  return (
    <div>
      <Container>
        <Row className="justify-content-center mb-3">
          <Col xs={11} lg={9} className="mt-3">
            <Row className="justify-content-center  g-3">
              <Form>
                <Col xs={12} className="rgc-info">
                
                <Row>
                  <Col xs={7} md={4} className="ms-auto">
                    <Form.Group className="mb-3 rgc-input-icons" controlId="formBasicCode">
                      <Form.Label>جستجو کد ملی </Form.Label>
                      <i class="fas fa-search"
                        aria-hidden="true"
                        style={{ cursor: "pointer" }}
                        onClick={searchHandler}
                      ></i>
                      <Form.Control
                        autoComplete="off"
                        type="number"
                        placeholder="کد ملی"
                        className="rgc-profile-input"
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        value={codeMeli}
                        onChange={(e) => setCodeMeli(e.target.value)}
                        onKeyDown={(event) => keyPress(event)}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col xs={12} md={4}>
                    <Form.Group className="mb-3 rgc-input-icons" controlId="formBasicName">
                      <Form.Label>نام و نام خانوادگی</Form.Label>
                      <i className='fas fa-user-alt'></i>
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder="نام و نام خانوادگی"
                        className="rgc-profile-input"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        onKeyDown={handleEnter}
                      />
                    </Form.Group>
                  </Col>

                  <Col xs={12} md={4}>
                    <Form.Group className="mb-3 rgc-input-icons" controlId="formBasicNumber">
                      <Form.Label>شماره همراه</Form.Label>
                      <i class="fas fa-mobile-alt" aria-hidden="true"></i>
                      <Form.Control
                        autoComplete="off"
                        type="number"
                        placeholder="شماره همراه"
                        className="rgc-profile-input"
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        value={mobile}
                        onChange={(e) => setMobile(e.target.value)}
                        onKeyDown={handleEnter}
                      />
                    </Form.Group>
                  </Col>

                  <Col xs={12} md={4}>
                    <Form.Group className="mb-3 rgc-input-icons" controlId="formBasicName">
                      <Form.Label> کدملی  </Form.Label>
                      <i className='fas fa-user-alt'></i>
                      <Form.Control
                        autoComplete="off"
                        type="number"
                        placeholder="کدملی"
                        className="rgc-profile-input"
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        value={codeMeli}
                        onChange={(e) => setCodeMeli(e.target.value)}
                        onKeyDown={handleEnter}
                      />
                    </Form.Group>
                  </Col>

                  <Col xs={12} md={6} className="text-center m-auto py-3">
                    <Form.Group className="rgc-input-icons text-center " controlId="formBasicName">
                      <Form.Label>
                        شماره شبا جهت واریزی نقدی(شماره شبا باید به نام خودتان باشد)
                      </Form.Label>
                      <InputGroup className="mb-1 rgc-input">
                          <InputGroup.Text id="basic-addon1" className="rgc-code">IR</InputGroup.Text>
                          <FormControl
                            type="number"
                              // className="rgc-code"
                             className="rgc-input-card rgc-time"
                            id="formBasicDate2"
                            value={cartNumber}
                            maxLength={24}
                          onChange={(e) => setCartNumber(e.target.value)} 
                          />
                          </InputGroup>
                      {/* <Form.Control
                        type="number"
                        className="
                        rgc-input-card rgc-time"
                        id="formBasicDate2"
                        value={cartNumber}
                        maxLength={24}
                        onChange={(e) => setCartNumber(e.target.value)} 
                      /> */}
                    </Form.Group>
                  </Col>
                  {/* <Col xs={12}  className="text-center my-3">
                    <Form.Group controlId="formBasicDate2">
                      <Form.Label>
                        شماره شبا جهت واریزی نقدی(شماره شبا باید به نام خودتان باشد)
                      </Form.Label>

                    </Form.Group>
                   <div className="d-flex rgc-credit justify-content-center">                      
                    <MaskInput 
                    onChange={(e) => setCartNumber(e.target.value)} 
                    maskChar="-" 
                    mask={'00 0000 0000 0000 0000 0000 00'} 
                    alwaysShowMask 
                    size={30}
                    value={cartNumber}
                    className="rgc-input-card rgc-time"
                    />
                     <div>IR</div>
                    </div>
                  </Col> */}

                  <Col xs={12} className="text-center">
                    <Button className="rgc-order-btn-info rgc-order-btn-sub" onClick={submitInfoHandler}>
                      <Loaders loads={snip1} />
                      ثبت
                    </Button>
                  </Col>
                </Row>
                </Col>
              </Form>

              <Col xs={12} className="rgc-score-items">
                <Row className="justify-content-center">
                  <Col xs={12} md={7}>
                    <Row className="justify-content-center">
                      <Col xs={6} className="text-md-center mb-2">
                        <span>دریافت مبلغ به صورت</span>
                      </Col>
                      <Col xs={6} className="mb-2">
                        <Form.Select
                          className="rgc-score-select"
                          value={convertId}
                          onChange={(e) => selectAreaHandler(e)}
                        >
                          <option key={0} value="0">
                            لطفا انتخاب کنید
                          </option>
                          {listConvert.map((data, index) => (
                            <option key={index} value={data.ParaCode + "/" + data.lvl + "/" + data.Oid}>
                              {data.Title}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>

                      <Col xs={6} className="text-md-center mb-3">
                        <span> مقدار مبلغ</span>
                      </Col>

                      <Col xs={6} className="mb-3">
                        <Form.Group controlId="formBasicVal">
                          <Form.Control
                            autoComplete="off"
                            className="rgc-score-input"
                            type="number"
                            placeholder=""
                            value={coint}
                            onChange={(e) => CointHandler(e)}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                          />
                        </Form.Group>
                      </Col>

                      <Col xs={6} className="text-md-center">

                      </Col>

                      <Col xs={6} className="text-center rgc-profile">
                        <span>{Sumcoint}</span>
                      </Col>

                      <Col xs={6} sm={4} className="text-center pt-4 pt-sm-0">
                        <Button className="rgc-orderreg-btn rgc-order-btn-sub"
                          onClick={() => convertHandler(0)} >
                          <Loaders loads={snip3} />
                          ارسال
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>

              <Col xs={12} className="rgc-score-items">
                <Row className="justify-content-center">
                  <Col xs={12} md={8} lg={7}>
                    <Row className="justify-content-center align-items-center">

                      <Col xs={12}  className="text-center mb-2">
                        <span>انتقال مبلغ به ریال</span>
                      </Col>

                      <Col xs={10} md={8} className="text-end">
                        <div className="d-flex flex-column">
                          <Form.Group  className="d-flex">
    
                            <Form.Control
                              autoComplete="off"
                              className="rgc-score-input"
                              type="number"
                              placeholder=""
                              value={cointTransfer}
                              onChange={(e) => setCointTransfer(e.target.value)}
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                            />
                          </Form.Group>
                        </div>
                      </Col>
                      <Col xs={8} className="my-3">
                        <Row className="justify-content-center g-0 ">

                          <Col xs={6}  >
                            <animated.button
                              onClick={orgClicked}
                              id="loginBtn"
                              style={orgBtn}
                              className='rgc-select-content rgc-select-content-right'
                            >
                              <span >موسسات خیریه</span>
                            </animated.button>
                          </Col>

                          <Col xs={6} className="rgc-dash-filter">
                            <animated.button
                              className='rgc-select-content rgc-select-content-left'
                              onClick={personClicked}
                              id="registerBtn"
                              style={personBtn}
                            >
                              <span> سایر</span>
                            </animated.button>
                          </Col>
                        </Row>
                      </Col>

                      <Col xs={12}>
                        <Row className="justify-content-center">
                          <Col xs={9}  className={selectFile === false ? "d-block" : "d-none"} >
                            <Form.Group  className="d-flex mt-2">
                              <Form.Label className="rgc-score-label text-center">به کد شماره</Form.Label>
                              <Form.Control
                                autoComplete="off"
                                className="rgc-score-input"
                                type="number"
                                placeholder=""
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                                onKeyPress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                              />
                            </Form.Group>
                          </Col>

                          <Carousel
                            responsive={responsive}
                            centerMode={true}
                            arrows={false}
                          >
                            {listOrg.map((data, index) => {
                              return (

                                <Col xs={9}  key={index} className={selectFile === true ? "d-block m-auto" : "d-none"}>
                                  <Ripples className="rgc-ripple">
                                    <Row className={orgId === data.Code.toString() ?
                                      "justify-content-center g-0 rgc-station-time-select rgc-station-select"
                                      : "justify-content-center g-0 rgc-station-time-select"}>
                                      <Col xs={4} className="text-center">
                                        <div className="radio">
                                          <input
                                            type="radio"
                                            value={data.Code.toString()}
                                            className="rgc-checkbox-select mt-2 me-2"
                                            checked={orgId === data.Code.toString()}
                                            onChange={(e) => setOrgId(e.target.value)}
                                          />
                                        </div>
                                      </Col>

                                      <Col xs={7} className="text-center rgc-address-text">
                                        <div className="d-flex flex-column justify-content-center rgc-checkbox-select-item">
                                          <Image className="rgc-image" src={charity}></Image>
                                          <span>{data.Name}</span>
                                        </div>

                                      </Col>

                                    </Row>
                                  </Ripples>
                                </Col>
                              )
                            })}
                          </Carousel>

                        </Row>
                      </Col>


                      <Col xs={12} className="text-center pt-4">
                        <Button className="rgc-orderreg-btn rgc-order-btn-sub"
                          onClick={() => convertHandler(1)} >
                          <Loaders loads={snipTransfer} />
                          ارسال
                        </Button>
                      </Col>
                      {/* <Col xs={8} className="my-3">
                        <Row className="justify-content-center g-0 ">

                          <Col xs={6}  >
                            <animated.button
                              onClick={orgClicked}
                              id="loginBtn"
                              style={orgBtn}
                              className='rgc-select-content rgc-select-content-right'
                            >
                              <span >موسسات خیریه</span>
                            </animated.button>
                          </Col>

                          <Col xs={6} className="rgc-dash-filter">
                            <animated.button
                              className='rgc-select-content rgc-select-content-left'
                              onClick={personClicked}
                              id="registerBtn"
                              style={personBtn}
                            >
                              <span> سایر</span>
                            </animated.button>
                          </Col>
                        </Row>
                      </Col>

                      <Col xs={12}>
                        <Row className="justify-content-center">
                          <Col xs={9}  className={selectFile === false ? "d-block" : "d-none"} >
                            <Form.Group  className="d-flex mt-2">
                              <Form.Label className="rgc-score-label text-center">به کد شماره</Form.Label>
                              <Form.Control
                                autoComplete="off"
                                className="rgc-score-input"
                                type="number"
                                placeholder=""
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                                onKeyPress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                              />
                            </Form.Group>
                          </Col>

                          <Carousel
                            responsive={responsive}
                            centerMode={true}
                            arrows={false}
                          >
                            {listOrg.map((data, index) => {
                              return (

                                <Col xs={9}  key={index} className={selectFile === true ? "d-block m-auto" : "d-none"}>
                                  <Ripples className="rgc-ripple">
                                    <Row className={orgId === data.Code.toString() ?
                                      "justify-content-center g-0 rgc-station-time-select rgc-station-select"
                                      : "justify-content-center g-0 rgc-station-time-select"}>
                                      <Col xs={4} className="text-center">
                                        <div className="radio">
                                          <input
                                            type="radio"
                                            value={data.Code.toString()}
                                            className="rgc-checkbox-select mt-2 me-2"
                                            checked={orgId === data.Code.toString()}
                                            onChange={(e) => setOrgId(e.target.value)}
                                          />
                                        </div>
                                      </Col>

                                      <Col xs={7} className="text-center rgc-address-text">
                                        <div className="d-flex flex-column justify-content-center rgc-checkbox-select-item">
                                          <Image className="rgc-image" src={charity}></Image>
                                          <span>{data.Name}</span>
                                        </div>

                                      </Col>

                                    </Row>
                                  </Ripples>
                                </Col>
                              )
                            })}
                          </Carousel>

                        </Row>
                      </Col>


                      <Col xs={12} className="text-center pt-4">
                        <Button className="rgc-orderreg-btn rgc-order-btn-sub"
                          onClick={() => convertHandler(1)} >
                           <Loaders loads={snip4} />
                          ارسال
                        </Button>
                      </Col> */}

                    </Row>
                  </Col>


                </Row>
              </Col>

{/* old */}
              {/* <Col xs={12} className="rgc-score-items">
                <Row className="justify-content-center">
                  <Col xs={12} md={8} lg={7}>
                    <Row className="justify-content-center align-items-center">

                      <Col xs={3} md={4} lg={6} className="text-center">
                        <span>انتقال مبلغ</span>
                      </Col>

                      <Col xs={9} md={8} lg={6} className="text-end">
                        <div className="d-flex flex-column">
                          <Form.Group controlId="formBasicCode" className="d-flex">
                            <Form.Label className="rgc-score-label text-center m-2">به میزان</Form.Label>
                            <Form.Control
                              autoComplete="off"
                              className="rgc-score-input"
                              type="number"
                              placeholder=""
                              value={cointTransfer}
                              onChange={(e) => setCointTransfer(e.target.value)}
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                            />
                            <Form.Label className="text-center m-2">مبلغ</Form.Label>
                          </Form.Group>

                          <Form.Group controlId="formBasicVal" className="d-flex mt-2">
                            <Form.Label className="rgc-score-label text-center">به کد شماره</Form.Label>
                            <Form.Control
                              autoComplete="off"
                              className="rgc-score-input"
                              type="number"
                              placeholder=""
                              value={code}
                              onChange={(e) => setCode(e.target.value)}
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                            />
                          </Form.Group>
                        </div>
                      </Col>

                      <Col xs={12} className="text-center pt-4">
                        <Button className="rgc-orderreg-btn rgc-order-btn-sub"
                          onClick={() => convertHandler(1)} >
                          <Loaders loads={snip4} />
                          ارسال
                        </Button>
                      </Col>

                    </Row>
                  </Col>
                </Row>
              </Col> */}

              <Col xs={6}>
                <div className="d-flex rgc-title pt-1">
                  <div className="rgc-title-point"></div>
                  <h4>تمامی <span>تراکنش ها</span></h4>
                </div>
              </Col>

              <Col xs={6} md={3} className="text-start me-auto">
                <Form.Select
                  className="rgc-select"
                  value={transaction}
                  onChange={(e) => setTransaction(e.target.value)}
                >
                  <option value="0">در انتظار تایید </option>
                  <option value="1">تایید شده</option>
                </Form.Select>
              </Col>

              <Col xs={12} className="mt-3">
                <Row className="justify-content-center rgc-score-header">
                  <Col xs={3} className="text-center">
                    <span>مبلغ</span>
                  </Col>
                  <Col xs={3} className="text-center">
                    <span>تاریخ تبدیل</span>
                  </Col>
                  <Col xs={6} className="text-center rgc-orderreg-txt">
                    <span>نوع تراکنش</span>
                  </Col>
                </Row>
              </Col>

              {listTransaction.map((data, index) => {
                return (
                  <Col xs={12} key={index}>
                    <Row className="justify-content-center rgc-orderreg-items rgc-score-body">
                      <Col xs={3} className="text-center">
                        <span>{Intl.NumberFormat('en-US').format(data.Coint)}</span>
                      </Col>
                      <Col xs={3} className="text-center">
                        <span>{data.Date}</span>
                      </Col>
                      <Col xs={6} className="text-center">
                        {data.Type == 0 ?
                          <span>تبدیل به:<span className="mx-2">{data.Tittle}</span></span>
                          :
                          <span>انتقال به:<span className="mx-2">{data.Code_Dist}</span></span>
                        }

                      </Col>
                    </Row>
                  </Col>
                )
              })}
            </Row>
          </Col>
        </Row>
      </Container >
    </div >
  )
}

export default Wallet